<template>
    <div class="container">
        <div class="free-trial-box">
            <!-- <h3 class="popup-title">{{$t('lisa_web_hello')}}</h3> -->
            <h3 class="popup-title" style="width: 275px;">{{ $t('learn') }} <b style="color: #FA450F;">{{ $t('english') }}</b>  {{ $t('through') }} <b style="color: #00A3FF;">{{ $t('mathematics') }}</b>  {{ $t('and') }} <b style="color: #00A3FF;">{{ $t('science') }}</b> </h3>
            <div class="trial-img-title">
                <!-- <img src="/themes/web/assets/images/grades.svg" alt=""> -->
                <img src="/themes/web/assets/images/icon_try_now.svg" alt="">
            </div>
            <!-- <h3 class="popup-title" style="font-size:16px">{{$t('great_let_s_choose_a_grade')}}</h3> -->
            <!-- <h3 class="popup-description mb-12">{{$t('we_will_set_up_a_new_account_depending_on_your_grade')}}</h3> -->

            <h3 class="popup-title" style="font-size:16px; padding: 20px;">{{$t('choose_your_grade')}}</h3>



            <div class="grade-select-body">
                <div class="grade-select-body">
                    <div class="grade-select-list">
                        <div @click="selectGrade(6)"
                             :class="checkGradeSelected(6)?['grade-select-item', 'active']:['grade-select-item']">6
                        </div>
                        <div @click="selectGrade(7)"
                             :class="checkGradeSelected(7)?['grade-select-item', 'active']:['grade-select-item']">7
                        </div>
                        <div @click="selectGrade(8)"
                             :class="checkGradeSelected(8)?['grade-select-item', 'active']:['grade-select-item']">8
                        </div>
                        <div @click="selectGrade(9)"
                             :class="checkGradeSelected(9)?['grade-select-item', 'active']:['grade-select-item']">9
                        </div>
                    </div>
                </div>
            </div>
            <!--<div class="text-center">-->
                <!--<div class="lisa-btn-small mt-20 active" style="margin: 15px auto;">-->
                    <!--Confirm-->
                <!--</div>-->
            <!--</div>-->
            <div class="text-center">
                <div class="lisa-btn-fit" v-if="grade_selected" :class="grade_selected ? 'active' : ''"
                     style="margin: 20px auto" @click="onSubmit">
                    {{$t('try_now')}}
                </div>
                <div class="lisa-btn-fit" v-if="grade_selected == ''" style="margin: 20px auto">
                    {{$t('try_now')}}
                </div>
            </div>
            <!-- <div class="free-trial-bottom">
                <h3 class="popup-title">{{$t('lisa_web_already_have_an_account')}}</h3>
                <a href="/login" class="btn-login">{{$t('login')}}</a>
                <div class="menu-item select-lang" @click="selectLang">
                    <img class="flag" :src="locate_info.img_flag" alt="" />
                    <span class="menu-text">{{ $t(locate_info.lang) }}</span>
                </div>
            </div> -->

        </div>
    </div>
    <!--<div class="container">-->
    <!--<div class="free-trial-box">-->
    <!--<h3 class="popup-title">{{$t('hello')}}</h3>-->
    <!--<div class="trial-img-title">-->
    <!--<img src="/themes/ito/images/image01/grade.png" alt="">-->
    <!--</div>-->
    <!--<h3 class="popup-title">{{$t('choose_grade_1')}}</h3>-->
    <!--<h3 class="popup-description mb-20">{{$t('choose_grade_2')}}</h3>-->

    <!--<div class="grade-select-body">-->
    <!--<div class="grade-select-list">-->
    <!--<div @click="selectGrade(1)"-->
    <!--:class="checkGradeSelected(1)?['grade-select-item', 'active']:['grade-select-item']">1-->
    <!--</div>-->
    <!--<div @click="selectGrade(2)"-->
    <!--:class="checkGradeSelected(2)?['grade-select-item', 'active']:['grade-select-item']">2-->
    <!--</div>-->
    <!--<div @click="selectGrade(3)"-->
    <!--:class="checkGradeSelected(3)?['grade-select-item', 'active']:['grade-select-item']">3-->
    <!--</div>-->
    <!--<div @click="selectGrade(4)"-->
    <!--:class="checkGradeSelected(4)?['grade-select-item', 'active']:['grade-select-item']">4-->
    <!--</div>-->
    <!--<div @click="selectGrade(5)"-->
    <!--:class="checkGradeSelected(5)?['grade-select-item', 'active']:['grade-select-item']">5-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="text-center">-->
    <!--<div class="ito-btn-small mt-20" v-if="grade_selected" :class="grade_selected ? 'active' : ''" style="width: 115px; margin: 15px auto;" @click="onSubmit">-->
    <!--{{$t('confirm')}}-->
    <!--</div>-->
    <!--<div class="ito-btn-small mt-20" v-if="grade_selected == ''" style="width: 115px; margin: 15px auto;">-->
    <!--{{$t('confirm')}}-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="free-trial-bottom">-->
    <!--<h4>Already have an account?</h4>-->
    <!--<a href="/login" class="ito-btn-small active mt-20" style="width: 115px;">{{$t('login')}}</a>-->
    <!--<div class="menu-item select-lang" data-dismiss="modal" data-toggle="modal" data-target="#selectLangModal">-->
    <!--<span class="menu-text">{{ $t('language') }}</span>-->
    <!--<img class="flag" :src="locate_info.img_flag" alt="" />-->
    <!--</div>-->
    <!--</div>-->

    <!--</div>-->
    <!--</div>-->

</template>

<script>
    import {authRegisterAnomynous} from '../../models/auth'
    import axios from "axios";
    import {mapGetters} from 'vuex'
    import {getAvatars, getConfig} from "../../models/profile";
    import {getConfigs, getLanguage, soundClick} from "../../utils/utils";

    export default {
        name: "RegisterAnomynous",
        data() {
            const configs = getConfigs();
            const locate = getLanguage();
            const localizes = configs.localize || [];

            let locate_info = {};
            localizes.forEach(item => {
                if (item.lang == locate) {
                    locate_info = item;
                }
            });
            return {
                error: {
                    message: '',
                },
                grade_selected: '',
                locate: getLanguage(),
                locate_info: locate_info,
                configs: configs,
                localizes: localizes,
            };
        },
        computed: {
            ...mapGetters([
                'user_info'
            ], () => {
                if (this.user_info) {
                    return this.user_info
                }

                return this.user
            })
        },
        created() {
            //this.$store.commit("setLoading", true);

            this.fetch();
        },
        mounted() {
            // $('#updateGradeModal').modal('show');
        },
        methods: {
            async fetch() {
                const that = this;

                await axios.all([
                    getConfig(),
                ]).then(axios.spread((response) => {
                    if (response.data.code != 0) {
                        return;
                    }

                    const configs = response.data.results || {};
                    const localizes = configs.localize || [];

                    localizes.forEach(item => {
                        if (item.lang == that.locate) {
                            that.locate_info = item;
                        }
                    });

                    //that.$store.commit("setLoading", true);
                    that.$store.commit("setConfigs", configs);

                    localStorage.setItem('configs', JSON.stringify(configs));
                }));
            },
            selectGrade(grade) {
                this.grade_selected = grade;
            },

            checkGradeSelected(grade) {
                return this.grade_selected == grade;
            },
            onSubmit(e) {
                this.resetErrorsValid();

                if (this.error.message != '') {
                    return false;
                }
                const grade = this.grade_selected;

                this.login({grade});

                e.preventDefault();
            },
            selectLang(){
                $('#languageModal').modal('show');
            },
            resetErrorsValid() {
                this.error = {
                    message: '',
                }
            },

            login(user) {
                const that = this;

                that.$store.commit("setLoading", true);

                authRegisterAnomynous(user).then((response) => {
                    that.$store.commit("setLoading", false);

                    if (response.data.code != 0) {
                        this.error.message = response.data.msg;

                        return false;
                    }

                    that.$store.commit('setAuth', true);
                    that.$store.commit("SET_ROLE_TYPE", 'student');
                    localStorage.removeItem('checkedSubjects');
                    localStorage.setItem('access_token', response.data.results.access_token);

                    location.href = '/';
                }).catch(({response}) => {
                    this.$store.commit('setAuth', false);
                    that.$store.commit("setLoading", false);

                    that.error.message = 'An error occurred, please try again later.';
                });
            }
        }
    }
</script>

<style scoped>
    .container{
        height: 100%;
    }
    .form-group {
        position: relative;
    }

    .ito-input {
        width: 100%;
    }
    .free-trial-box{
        position: relative;
        top:calc(50% - 84px - 150px);
        width: 468px;
        /* height: 425px; */
        height: 400px;
        background: #ffffff;
        margin: auto;
        padding: 20px;
        text-align: center;
        box-shadow: 4px 4px 0px rgba(0,0,0,0.07), inset 0px 4px 0px rgba(231,231,231,0.25);
        border-radius: 8px;
        overflow: hidden;
    }
    .trial-img-title img{
        /* width: 80px;
        height: 80px; */
        /* margin: 10px auto; */
        margin-top: 16px;
    }
    .free-trial-bottom{
        position: absolute;
        width: 100%;
        margin: auto;
        left: 0;
        bottom: 0;
        padding: 12px;
        background: #EEEEEE;
        height: 95px;
    }
    .free-trial-bottom .menu-item .menu-text{
        font-weight: 600;
        font-size: 12px;
        margin-left: 8px;
    }
    .free-trial-box a{
        display: block;
        margin: 10px auto;
        cursor: pointer;
        color: #ffffff;
    }
    .free-trial-box a:hover{
        text-decoration: none;
        color: #ffffff;
    }
    .free-trial-bottom h3{
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 19px;
        letter-spacing: 0px;
        color: #070A28;
    }
    .select-lang{
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 19px;
        right: 20px;
        padding: 6px 8px;
        background: #ffffff;
        border-radius: 8px;
        cursor: pointer;
        box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.15);
    }
    .btn-login{
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 19px;
        background: linear-gradient(180deg, #FFAF43 0%, #FD970C 100%);
        border-radius: 8px;
        height: 35px;
        padding: 8px 20px;
        width: fit-content;
    }
    .lisa-btn{
        height: 35px;
        display: flex;
        align-items: center;
        font-size: 14px;
    }
    .popup-description{
        font-weight: 400;
        font-size: 12px;
        color: #070A28;
    }
</style>
